import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7abb5c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "finding-scalar flex justify-space-between" }
const _hoisted_2 = {
  key: 0,
  class: "finding-container flex-grow"
}
const _hoisted_3 = {
  key: 0,
  class: "flex align-center justify-space-between"
}
const _hoisted_4 = { class: "flex-grow finding-value" }
const _hoisted_5 = ["title"]

import IbIcons from "@/components/icons/ib-icons.vue";
import { Insight } from '@/models/insight';
import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Scalar',
  props: {
  insight: {
    type: Object as PropType<Insight>,
    required: true,
  },
},
  emits: ["copyAIFindings"],
  setup(__props, { emit }) {

const props = __props;





const displayValue = computed(() => {
  let result = "";
  if (props.insight?.value !== "undefined") {
    result = props.insight?.value;
    if (props.insight?.suffix) {
      if (props.insight?.suffix==="%"){
        result = `${parseFloat(props.insight?.value).toFixed(2)} ${props.insight?.suffix}`;
      } else {
        result = `${parseFloat(props.insight?.value).toFixed(1)} ${props.insight?.suffix}`;
      }
    }
  }
  return result;
})

const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IbIcons, {
      icon: "ai",
      size: "14",
      class: "ai-icon"
    }),
    (__props.insight.value!=='undefined' && __props.insight.value!==null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.insight.value!=='undefined' && __props.insight.value!==null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(displayValue)), 1),
                _createVNode(IbIcons, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('copyAIFindings'))),
                  icon: "populate",
                  color: "primary",
                  size: "14"
                })
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "flex-grow na",
          title: _unref(t)('insights.not_calculated')
        }, _toDisplayString(_unref(t)('insights.na')), 9, _hoisted_5))
  ]))
}
}

})